<template>
  <base-page-layout title="Ofertas do aplicativo">
    <mf-tabs-menu v-model="currentTab" class="mb-5" :tabs="permissionedMobileOffersTabs" />
    <router-view />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'

export default {
  components: {
    BasePageLayout,
  },
  data: () => ({
    currentTab: null,
  }),
  computed: {
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    mobileOffersTabs() {
      return [
        {
          name: 'Produtos',
          to: '/mobile/ofertas/produtos/edicao',
          tabPermission: 'mobile/ofertas/produtos/edicao',
        },
        {
          name: 'Destaques',
          to: '/mobile/ofertas/destaques',
          tabPermission: 'mobile/ofertas/destaques',
        },
      ]
    },
    permissionedMobileOffersTabs() {
      let tabs = []
      this.mobileOffersTabs.forEach((tab) => {
        if (this.$permissions.havePagePermission(tab.tabPermission)) {
          tabs.push(tab)
        }
      })
      return tabs
    },
  },
  watch: {
    currentTab(tab) {
      if (this.$route.path !== this.permissionedMobileOffersTabs[tab].to) {
        this.$router.push(this.permissionedMobileOffersTabs[tab].to).catch(() => {})
      }
    },
  },
  mounted() {
    document.title = 'Ofertas'
    this.setInitialTab()
  },
  beforeUpdate() {
    if (this.$route.path === '/mobile/ofertas/destaques/editar/ativaveis' || this.$route.path === '/mobile/ofertas/destaques/editar/livres') {
      return
    }
    this.setInitialTab()
  },
  methods: {
    setInitialTab() {
      if (this.$route.path === '/mobile/ofertas') {
        this.$router.push(this.permissionedMobileOffersTabs[0].to).catch(() => {})
        this.currentTab = 0
        return
      }
      const index = this.permissionedMobileOffersTabs.findIndex((p) => p.to === this.$route.path)
      this.currentTab = index === -1 ? 0 : index
    },
  },
}
</script>

<style lang="scss" scoped></style>
